import './DownloadBySchool.css';
import { useState, useEffect } from 'react';
import { Autocomplete, TextField, Checkbox, CircularProgress, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import domtoimage from 'dom-to-image-chrome-fix-retina';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import StandardOutlinedTextfield from '../../components/StandardOutlinedTextfield/StandardOutlinedTextfield';
import DownloadIcon from '@mui/icons-material/Download';
// Components
import StandardPageWrapper from '../../components/StandardPageWrapper/StandardPageWrapper';
import CustomMuiSelect from '../../components/CustomMuiSelect/CustomMuiSelect';
import StandardButton from '../../components/StandardButton/StandardButton';
import StandardPreviewCardDownload from '../../components/StandardPreviewCardDownload/StandardPreviewCardDownload';
// ICONs & SVGs
import SearchIcon from '@mui/icons-material/Search';

function DownloadBySchool() {
    const { enqueueSnackbar } = useSnackbar();

    const [allIDCards, setAllIDCards] = useState([]);
    const [allIDCardsStorage, setAllIDCardsStorage] = useState([]); // Data in this card wont change
    const [allIDCardsCheckBox, setAllIDCardsCheckBox] = useState({});

    const [allBtnData, setAllBtnData] = useState({ school: '', is_verified: '' });
    const [allSchoolData, setAllSchoolData] = useState([]);

    const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);
    const [searchLoading, setSearchLoading] = useState(false);

    const [cardType, setCardType] = useState('all');

    // ----------------------
    const [downloadAllLoading, setDownloadAllLoading] = useState(false);
    const [downloadSelectedLoading, setDownloadSelectedLoading] = useState(false);

    const [openCountModal, setOpenCountModal] = useState(false);
    const [startCount, setStartCount] = useState({ oneSideFront: 1, bothSideFront: 1, bothSideBack: 1 });

    useEffect(() => {
        fetchAllSchools();
    }, [])

    const fetchAsIsVerified = async (e) => {
        setAllBtnData({ ...allBtnData, is_verified: e.target.value })
    }
    const fetchAllSchools = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getallschool`)
            .then(res => {
                if (res.data.success) {
                    setAllSchoolData(res.data.data)
                } else {
                    enqueueSnackbar('Error Fetching Schools, Try Again !!!', { variant: 'error' })
                }
                setAllSchoolDataLoading(false);
            })
            .catch(err => {
                console.log(err);
                setAllSchoolDataLoading(false);
                return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
            })
    }

    const updateIsDownloaded = async () => {
        const payload = {
            "school_id": [allBtnData.school]
        }
        await axios
            .post(
                `${process.env.REACT_APP_BASE_URL}/user/update_is_downloaded`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                if (res.data.success) {
                    // setAllUserData(res.data.data);
                } else {
                    enqueueSnackbar("Error Updating is_downloaded, Try Again !!!", {
                        variant: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                return enqueueSnackbar("Something Went Wrong !!!", {
                    variant: "error",
                });
            });
    };

    const onSearchByClass = async () => {
        if (Object.values(allBtnData).includes('')) {
            return enqueueSnackbar('Please Select All The Values !!!', { variant: 'error' });
        }

        setSearchLoading(true);

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/user/getmapped_data_byschoolid`,
                { school_id: allBtnData.school }
            );

            if (!res.data.success) {
                setAllIDCards([]);
                enqueueSnackbar(res.data.message, { variant: 'error' });
                return;
            }

            let checkboxObj = {};

            // ✅ PROCESS ALL ELEMENTS
            const updatedResponseData = res.data.data.map(item => {
                let updatedUserData = [];

                for (let i = 0; i < item.user_data.length; i++) {
                    const user = item.user_data[i];

                    if (allBtnData.is_verified === '1' && user.is_verified !== 1) continue;
                    if (allBtnData.is_verified === '0' && user.is_verified !== 0) continue;

                    updatedUserData.push(user);

                    checkboxObj[`standardPreviewCard_selectID_${user.mapped_id}`] = false;
                }

                return {
                    ...item,
                    user_data: updatedUserData
                };
            });

            setAllIDCards(updatedResponseData);
            setAllIDCardsStorage(updatedResponseData);
            setAllIDCardsCheckBox(checkboxObj);

        } catch (err) {
            console.log(err);
            enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
        } finally {
            setSearchLoading(false);
        }
    };


    const onDownloadAllClick = async () => {
        const zip = new JSZip();
        setDownloadAllLoading(true);

        // ✅ collect ALL users from ALL elements
        const allUsers = allIDCards.flatMap(item => item.user_data || []);
        const verifiedUsers = allUsers.filter(u => u.is_verified === 1);

        const totalUsers = allUsers.length;
        const verifiedCount = verifiedUsers.length;
        const unverifiedCount = totalUsers - verifiedCount;

        // ❌ no verified users
        if (verifiedCount === 0) {
            setDownloadAllLoading(false);
            return enqueueSnackbar(
                "No verified cards available for download!",
                { variant: "error" }
            );
        }

        // ⚠️ some skipped
        if (unverifiedCount > 0) {
            enqueueSnackbar(
                `${unverifiedCount} card(s) were unverified and skipped.`,
                { variant: "warning" }
            );
        }

        // ✅ all verified
        if (verifiedCount === totalUsers) {
            enqueueSnackbar("All cards are verified.", { variant: "success" });
        }

        // 🔑 assume same card type for all (safe in your case)
        const cardType = allIDCards?.[0]?.id_card?.type;

        let oneSideCount;
        let bothSideFrontCount;
        let bothSideBackCount;

        if (cardType == 1) {
            const oneSide = zip.folder("one-side");
            oneSideCount = startCount.oneSideFront;

            for (const user of verifiedUsers) {
                const frontNode = document.getElementById(
                    `previewcustomCard-front-${user.mapped_id}`
                );

                if (!frontNode) continue;

                try {
                    const dataUrl = await domtoimage.toPng(frontNode, { cacheBust: true });
                    oneSide.file(
                        `${oneSideCount}.png`,
                        dataUrl.split(",")[1],
                        { base64: true }
                    );
                    oneSideCount++;
                } catch (err) {
                    console.error("Error Downloading Image!", err);
                }
            }
        } else {
            const bothSideFront = zip.folder("both-side/front");
            const bothSideBack = zip.folder("both-side/back");

            bothSideFrontCount = startCount.bothSideFront;
            bothSideBackCount = startCount.bothSideBack;

            for (const user of verifiedUsers) {
                const frontNode = document.getElementById(
                    `previewcustomCard-front-${user.mapped_id}`
                );
                const backNode = document.getElementById(
                    `previewcustomCard-back-${user.mapped_id}`
                );

                if (!frontNode || !backNode) continue;

                try {
                    const frontImg = await domtoimage.toPng(frontNode, { cacheBust: true });
                    const backImg = await domtoimage.toPng(backNode, { cacheBust: true });

                    bothSideFront.file(
                        `${bothSideFrontCount}.png`,
                        frontImg.split(",")[1],
                        { base64: true }
                    );
                    bothSideBack.file(
                        `${bothSideBackCount}.png`,
                        backImg.split(",")[1],
                        { base64: true }
                    );

                    bothSideFrontCount++;
                    bothSideBackCount++;
                } catch (err) {
                    console.error("Error downloading image!", err);
                }
            }
        }

        const selectedSchoolName =
            allSchoolData?.find(s => s.schoolid === allBtnData.school)?.name;

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${selectedSchoolName} ID Cards.zip`);

        setDownloadAllLoading(false);
        setOpenCountModal(false);

        // ✅ send ALL verified IDs
        const verifiedIds = verifiedUsers.map(u => u.mapped_id);
        await onSendDownloadedSchoolsToServer(verifiedIds);
    };



    const onDownloadSelected = async () => {
        // 1️⃣ collect selected ids
        const selectedIds = Object.keys(allIDCardsCheckBox).filter(
            key => allIDCardsCheckBox[key]
        ).map(key => key.split("_")[2]);

        if (!selectedIds.length) {
            return enqueueSnackbar("Please Select Images !!!", { variant: "error" });
        }

        // 2️⃣ collect ALL users from ALL elements
        const allUsers = allIDCards.flatMap(item => item.user_data || []);

        // 3️⃣ only selected + verified
        const verifiedUsers = allUsers.filter(
            user =>
                selectedIds.includes(String(user.mapped_id)) &&
                user.is_verified === 1
        );

        const unverifiedCount = selectedIds.length - verifiedUsers.length;

        if (!verifiedUsers.length) {
            return enqueueSnackbar(
                "All selected cards are unverified. Nothing to download!",
                { variant: "error" }
            );
        }

        if (unverifiedCount > 0) {
            enqueueSnackbar(
                `${unverifiedCount} selected card(s) were unverified and skipped.`,
                { variant: "warning" }
            );
        }

        const zip = new JSZip();
        setDownloadSelectedLoading(true);

        // 4️⃣ detect card type (safe assumption: same type)
        const cardType = allIDCards?.[0]?.id_card?.type;

        if (cardType == 1) {
            const oneSide = zip.folder("one-side");
            let count = 1;

            for (const user of verifiedUsers) {
                const frontNode = document.getElementById(
                    `previewcustomCard-front-${user.mapped_id}`
                );

                if (!frontNode) continue;

                try {
                    const dataUrl = await domtoimage.toPng(frontNode, { cacheBust: true });
                    oneSide.file(`${count}.png`, dataUrl.split(",")[1], { base64: true });
                    count++;
                } catch (err) {
                    console.error("Error Downloading Image!", err);
                }
            }
        } else {
            const bothSideFront = zip.folder("both-side/front");
            const bothSideBack = zip.folder("both-side/back");
            let count = 1;

            for (const user of verifiedUsers) {
                const frontNode = document.getElementById(
                    `previewcustomCard-front-${user.mapped_id}`
                );
                const backNode = document.getElementById(
                    `previewcustomCard-back-${user.mapped_id}`
                );

                if (!frontNode || !backNode) continue;

                try {
                    const frontImg = await domtoimage.toPng(frontNode, { cacheBust: true });
                    const backImg = await domtoimage.toPng(backNode, { cacheBust: true });

                    bothSideFront.file(`${count}.png`, frontImg.split(",")[1], { base64: true });
                    bothSideBack.file(`${count}.png`, backImg.split(",")[1], { base64: true });

                    count++;
                } catch (err) {
                    console.error("Error downloading image!", err);
                }
            }
        }

        const selectedSchoolName =
            allSchoolData?.find(s => s.schoolid === allBtnData.school)?.name;

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${selectedSchoolName} Selected ID Cards.zip`);

        // 5️⃣ send only verified ids
        const verifiedIds = verifiedUsers.map(u => u.mapped_id);
        await onSendDownloadedSchoolsToServer(verifiedIds);

        setDownloadSelectedLoading(false);
    };


    const onSendDownloadedSchoolsToServer = async (arr) => {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updatedownloadstatus`, { ids: arr })
            .then(res => {
                if (res.data.success) {
                    console.log(res.data.result);
                } else {
                    enqueueSnackbar('Error Uploading Schools Array, Try Again !!!', { variant: 'error' })
                }
                setDownloadSelectedLoading(false);
            })
            .catch(err => {
                console.log(err);
                setDownloadSelectedLoading(false);
                return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
            })
    }

    // const onDownloadNotDownloaded = async () => {
    //     const notdownloadedArr = []
    //     allIDCards[0]?.user_data?.forEach(card => card?.is_downloaded !== 1 && notdownloadedArr?.push(card?.mapped_id));
    //     if (notdownloadedArr?.length <= 0) return enqueueSnackbar('All Images are Downloaded !!!', { variant: 'error' });

    //     const zip = new JSZip();

    //     setDownloadNotDownloadedLoading(true)

    //     if (allIDCards[0]?.id_card?.type == 1) {
    //         const oneSide = zip.folder("one-side");

    //         let oneSideCount = 1;
    //         for (let i = 0; i < notdownloadedArr?.length; i++) {
    //             var frontNode = document.getElementById(`previewcustomCard-front-${notdownloadedArr[i]}`);

    //             await domtoimage
    //                 .toPng(frontNode, { cacheBust: true })
    //                 .then(function (dataUrl) {
    //                     var img = new Image();
    //                     img.src = dataUrl; // base64 img
    //                     const b64data = dataUrl.split(",")[1];

    //                     oneSide.file(`${oneSideCount}.png`, b64data, { base64: true });
    //                 })
    //                 .catch(function (error) {
    //                     console.error("Error Downloading Image!", error);
    //                     setDownloadNotDownloadedLoading(false);
    //                 });

    //             oneSideCount++;
    //         }

    //     } else {
    //         const bothSideFront = zip.folder("both-side/front");
    //         const bothSideBack = zip.folder("both-side/back");

    //         let bothSideCount = 1;
    //         for (let i = 0; i < notdownloadedArr?.length; i++) {
    //             var frontNode = document.getElementById(`previewcustomCard-front-${notdownloadedArr[i]}`);
    //             var backNode = document.getElementById(`previewcustomCard-back-${notdownloadedArr[i]}`);

    //             await domtoimage
    //                 .toPng(frontNode, { cacheBust: true })
    //                 .then(function (dataUrl) {
    //                     var img = new Image();
    //                     img.src = dataUrl; // base64 img
    //                     const b64data = dataUrl.split(",")[1];

    //                     bothSideFront.file(`${bothSideCount}.png`, b64data, { base64: true });
    //                 })
    //                 .catch(function (error) {
    //                     console.error("Error Downloading Image!", error);
    //                     setDownloadNotDownloadedLoading(false);
    //                 });

    //             await domtoimage
    //                 .toPng(backNode, { cacheBust: true })
    //                 .then(function (dataUrl) {
    //                     var img = new Image();
    //                     img.src = dataUrl; // base64 img
    //                     const b64data = dataUrl.split(",")[1];

    //                     bothSideBack.file(`${bothSideCount}.png`, b64data, { base64: true });
    //                 })
    //                 .catch(function (error) {
    //                     console.error("Error Downloading Image!", error);
    //                     setDownloadNotDownloadedLoading(false);
    //                 });

    //             bothSideCount++;
    //         }

    //     }

    //     const selectedSchoolName = allSchoolData?.filter(s => s.schoolid === allBtnData.school)?.[0]?.name
    //     zip.generateAsync({ type: "blob" }).then(content => {
    //         saveAs(content, `${selectedSchoolName} Not Downloaded ID Cards.zip`);
    //         // onSendDownloadedSchoolsToServer(notdownloadedArr);
    //     });
    // }

    const onCardTypeChange = (e) => {
        const selectedType = e.target.value;
        let checkboxObj = {};

        // ✅ process ALL elements
        const updatedData = allIDCardsStorage.map(item => {
            let filteredUsers = [];

            switch (selectedType) {
                case 'downloaded':
                    filteredUsers = item.user_data.filter(u => u.is_downloaded === 1);
                    break;

                case 'not_downloaded':
                    filteredUsers = item.user_data.filter(u => u.is_downloaded !== 1);
                    break;

                case 'all':
                default:
                    filteredUsers = [...item.user_data];
                    break;
            }

            // build checkbox state
            filteredUsers.forEach(user => {
                checkboxObj[`standardPreviewCard_selectID_${user.mapped_id}`] = false;
            });

            return {
                ...item,
                user_data: filteredUsers
            };
        });

        setAllIDCards(updatedData);
        setAllIDCardsCheckBox(checkboxObj);
        setCardType(selectedType);
    };



    return (
        <StandardPageWrapper
            header="Download By School"
            btns={
                <>
                    {/* <CustomMuiSelect
                        label="Select School"
                        val={allBtnData.school}
                        onChange={(e) => setAllBtnData({ ...allBtnData, school: e.target.value })}
                        width={150}
                        size="small"
                        disabled={searchLoading}
                    >
                        {allSchoolData?.map((c, i) => (
                            <MenuItem value={c?.schoolid} key={i}>
                                {c?.name}
                            </MenuItem>
                        ))}
                    </CustomMuiSelect> */}
                    <Autocomplete
                        options={allSchoolData || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={allSchoolData.find((school) => school.schoolid === allBtnData.school) || null}
                        onChange={(event, newValue) => setAllBtnData({ ...allBtnData, school: newValue?.schoolid || "" })}
                        disabled={searchLoading}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select School"
                                size="small"
                                sx={{
                                    width: 150,
                                    backgroundColor: "white", // Setting the background color to white
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: 'lightgray', // Optional: Adjust border color
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'gray', // Optional: Change border color on hover
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'darkgreen', // Optional: Focus border color
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: 'black', // Default label color (before hover/focus)
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: 'black', // Label color when focused
                                    },
                                    '& .MuiInputLabel-root:hover': {
                                        color: 'black', // Label color when hovered
                                    },
                                }}
                                // style={{ width: 150 }}
                                disabled={searchLoading}
                            />
                        )}
                    />
                    <CustomMuiSelect
                        label="Is Verified"
                        val={allBtnData.is_verified}
                        onChange={fetchAsIsVerified}
                        // onChange={(e) =>
                        // setAllBtnData({ ...allBtnData, is_verified: e.target.value })
                        // }
                        width={150}
                        size="small"
                        sx={{ marginRight: 1.5 }}
                        disabled={searchLoading}
                    >
                        <MenuItem
                            value="all"
                            key="2"
                        >All</MenuItem>
                        <MenuItem
                            value="1"
                            key="1"
                        >Verified</MenuItem>
                        <MenuItem
                            value="0"
                            key="0"
                        >Not Verified</MenuItem>
                    </CustomMuiSelect>
                    <StandardButton
                        color="white"
                        variant="contained"
                        style={{ background: "darkgreen !important", marginLeft: '15px !important' }}
                        onClick={onSearchByClass}
                        label={<SearchIcon />}
                        loading={searchLoading}
                    />

                    {allIDCards?.length > 0 && (
                        <>

                            {/* <StandardButton
                                variant="contained"
                                onClick={onDownloadNotDownloaded}
                                loading={downloadNotDownloadedLoading}
                                style={{ background: "#032025 !important" }}
                                label="Not Downloaded"
                            /> */}
                            <CustomMuiSelect label="Select Card Type" val={cardType} onChange={onCardTypeChange}
                                width={140} size="small" disabled={searchLoading}
                            >
                                <MenuItem value='all'>All</MenuItem>
                                <MenuItem value='downloaded'>Downloaded</MenuItem>
                                <MenuItem value='not_downloaded'>Not Downloaded</MenuItem>
                            </CustomMuiSelect>
                            <StandardButton
                                variant="contained"
                                onClick={onDownloadSelected}
                                loading={downloadSelectedLoading}
                                style={{ background: "#0d7a8e !important" }}
                                label="Download Selected"
                            />
                            <StandardButton
                                variant="contained"
                                onClick={() => setOpenCountModal(true)}
                                loading={downloadAllLoading}
                                style={{ background: "darkgreen !important" }}
                                label="Download All"
                                startIcon={<DownloadIcon />}
                            />
                        </>
                    )}
                </>
            }
        >
            <div id="preview">
                <div className="previewCard_cont">
                    {searchLoading ? (
                        <CircularProgress
                            size={30}
                            sx={{ display: "block", margin: "auto", color: "#4b49ac" }}
                        />
                    ) : (
                        <>
                            {allIDCards?.map((item, itemIndex) =>
                                item?.user_data?.map((u, i) => (
                                    <div
                                        className="standardPreviewCard_parent"
                                        key={`${itemIndex}-${u?.mapped_id}`}
                                    >
                                        <Checkbox
                                            checked={
                                                allIDCardsCheckBox?.[`standardPreviewCard_selectID_${u?.mapped_id}`]
                                            }
                                            onChange={(e) =>
                                                setAllIDCardsCheckBox({
                                                    ...allIDCardsCheckBox,
                                                    [`standardPreviewCard_selectID_${u?.mapped_id}`]: e.target.checked
                                                })
                                            }
                                        />

                                        <StandardPreviewCardDownload
                                            custom_uid={u?.mapped_id}
                                            cardData={item?.id_card}   // 👈 IMPORTANT CHANGE 
                                            userData={u}
                                        />
                                    </div>
                                ))
                            )}
                        </>
                    )}
                </div>
            </div>
            <Dialog
                open={openCountModal}
                onClose={() => setOpenCountModal(false)}
                maxWidth={"md"}
                fullWidth
            >
                <DialogTitle>Enter Download Count</DialogTitle>
                <DialogContent>
                    <FormControl sx={{ width: "100%", overflowX: "hidden" }} fullwidth>
                        <StandardOutlinedTextfield
                            label="One Side Start Count"
                            name="oneSideFront"
                            val={startCount?.oneSideFront}
                            setVal={setStartCount}
                            spreadData={startCount}
                            default={1}
                        />
                        <StandardOutlinedTextfield
                            label="Both Side Start Front Count"
                            name="bothSideFront"
                            val={startCount?.bothSideFront}
                            setVal={setStartCount}
                            spreadData={startCount}
                        />
                        <StandardOutlinedTextfield
                            label="Both Side Back Front Count"
                            name="bothSideBack"
                            val={startCount?.bothSideBack}
                            setVal={setStartCount}
                            spreadData={startCount}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <button onClick={() => setOpenCountModal(false)}>Cancel</button>
                    <StandardButton
                        variant="contained"
                        onClick={onDownloadAllClick}
                        loading={downloadAllLoading}
                        label="Start Download"
                        startIcon={<DownloadIcon />}
                    />
                </DialogActions>
            </Dialog>
        </StandardPageWrapper>
    );
}

export default DownloadBySchool
